export default {
  line_items: [
    {
      lead_times: [1, 2, 3, 4, 5],
      pricing: [
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
      ],
      quantities: [4, 10, 20, 50],
      product_key: 'assembly-us',
    },
    {
      lead_times: [6, 8, 10],
      pricing: [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
      ],
      quantities: [
        'First Articles (1-10)',
        'Low Production (11-1000)',
        'High Production (>1000)',
      ],
      product_key: 'assembly-mx',
    },
  ],
};
